import styled from 'styled-components';
import { THEME } from '../../../../../../themes';
import {
  CaptionFont,
} from '../../../../../../themes/fonts';

export const Panel = styled.div`
  display:flex;
  flex-direction: column;
  margin-top: auto;
`;

export const PanelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${THEME.SPACING.MICRO} 0px;
`;

export const RoleCircle = styled.div<{
  size: number,
  color: string,
}>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border-radius: ${THEME.RADIUS.CIRCLE};
  background-color: ${({ color }) => color};
  margin-right: ${THEME.SPACING.TINY};
`;

export const RoleName = styled.div`
  opacity: ${THEME.OPACITY.MED};
  ${CaptionFont};
  font-weight: 600;
  color: ${THEME.COLORS.CONTENT_PRIMARY};
  flex: 1;
  margin-right: 5px;
`;

export const ExperienceValue = styled.div`
  opacity: ${THEME.OPACITY.LOW};
  ${CaptionFont};
  font-weight: 600;
  color: ${THEME.COLORS.CONTENT_PRIMARY};
  margin-left: auto;
`;
